import { InteractionStatus } from '@azure/msal-browser';
import { useMsal } from '@azure/msal-react';
import { useCurrentUser } from '@src/entities/User/ui/hooks/useCurrentUser';
import { PrivateRoutes } from '@src/pages/private';
import { ErrorHandler } from '@src/shared/ui/components/ErrorHandler';
import { IdleTimeout } from '@src/shared/ui/components/IdleTimeout';
import { Loader } from '@src/shared/ui/components/Loader';
import { ApplicationLayout } from '@src/shared/ui/layouts/Application';
import { useRouter } from '@uhg-abyss/web/hooks/useRouter';
import { config } from '@uhg-abyss/web/tools/config';
import React, { useEffect } from 'react';

/**
 * Private
 *
 * This component serves as a router for the private routes.
 *
 * @returns {Element}
 * @constructor
 */
export function Private() {
  const { inProgress, instance } = useMsal();
  const router = useRouter();
  const location = router.getLocation();
  const { hasAccess, hasRoles, msalAccount } = useCurrentUser();

  /**
   * unauthenticates a user with the application and redirects them to unauthorized screen
   */
  useEffect(() => {
    (async () => {
      if (inProgress === InteractionStatus.None && hasAccess === false) {
        await instance.logoutRedirect({
          account: instance.getAccountByHomeId(msalAccount?.homeAccountId),
          postLogoutRedirectUri: `${config('APP_URL')}/unauthorized`,
        });
      }
    })();
  }, [location?.pathname, inProgress, instance, msalAccount, hasAccess]);

  if (hasAccess !== true || hasRoles !== true || inProgress !== InteractionStatus.None) {
    return <Loader />;
  }

  return (
    <ErrorHandler location="src/app/components/Router/components/Private.jsx">
      <ApplicationLayout>
        <PrivateRoutes />
        {config('APP_ENV') !== 'local' && (
          <IdleTimeout
            handleLogout={() => {
              (async () => {
                await instance.logoutRedirect({
                  account: instance.getAccountByHomeId(msalAccount?.homeAccountId),
                  postLogoutRedirectUri: `${config('APP_URL')}/login?message=inactive`,
                });
              })();
            }}
          />
        )}
      </ApplicationLayout>
    </ErrorHandler>
  );
}
